// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3QjQW","footer404":"footer-module--footer-404--24TXF","labelHide":"footer-module--label-hide--4ayoM"};